/* eslint-disable no-unused-vars */
import React from 'react'
import Teamsection from '../views/Teams/Teamsection'

export default function Our_team_hickter() {
  return (
    <Teamsection/>
  )
}
